<template>
    <div class="modal" @keydown.esc="chatModalClosed" id="chatModal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document" style="max-height: 850px">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Chat</h5>
                    <button type="button" class="close" @click="chatModalClosed" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <chat-window v-if="showChat"
                                :current-user-id="currentUserId"
                                :show-add-room="false"
                                :show-files="false"
                                :show-audio="false"
                                :load-first-room="false"
                                :rooms="loadedRooms"
                                :loading-rooms="loadingRooms"
                                :rooms-loaded="roomsLoaded"
                                :messages="messages"
                                :messages-loaded="messagesLoaded"
                                @fetch-messages="fetchMessages"
                                @send-message="sendMessage"
                                @typing-message="typingMessage"
                                @delete-message="deleteMessage"
                                @edit-message="editMessage"
                                @send-message-reaction="sendMessageReaction"
                                :text-messages="translations"
                                :message-actions="messageActions"
                                :styles="styles.customTheme"
                            ></chat-window>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ChatWindow from 'vue-advanced-chat'
import 'vue-advanced-chat/dist/vue-advanced-chat.css'

export default {
    name: "Chat",
    components: {
        ChatWindow
    },
    data() {
        return {
            roomId: null,
            rooms: [],
            messages: [],
            currentUserId: 0,
            loadingRooms: true,
            roomsLoaded: false,
            messagesLoaded: false,
            roomsLoadedCount: false,
            totalUnreadMessageCount: 0,
            translations: {},
            roomActions: [],
            messagesPage: 1,
            styles: {
                customTheme: {
                    general: {
                        color: '#0a0a0a',
                        backgroundInput: '#fff',
                        colorPlaceholder: '#9ca6af',
                        colorCaret: '#1976d2',
                        colorSpinner: '#333',
                        borderStyle: '1px solid #e1e4e8',
                        backgroundScrollIcon: '#fff'
                    },

                    container: {
                        border: 'none',
                        borderRadius: '4px',
                        boxShadow:
                            '0px 1px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)'
                    },

                    header: {
                        background: '#fff',
                        colorRoomName: '#0a0a0a',
                        colorRoomInfo: '#9ca6af'
                    },

                    footer: {
                        background: '#f8f9fa',
                        borderStyleInput: '1px solid #e1e4e8',
                        borderInputSelected: '#1976d2',
                        backgroundReply: '#e5e5e6',
                        backgroundTagActive: '#e5e5e6'
                    },

                    content: {
                        background: '#f8f9fa'
                    },

                    sidemenu: {
                        background: '#fff',
                        backgroundHover: '#f6f6f6',
                        backgroundActive: '#f0f0f0',
                        colorActive: '#1976d2',
                        borderColorSearch: '#e1e5e8'
                    },

                    dropdown: {
                        background: '#fff',
                        backgroundHover: '#f6f6f6'
                    },

                    message: {
                        background: '#fff',
                        backgroundMe: 'rgba(247, 127, 0, 0.4)',
                        color: '#0a0a0a',
                        colorStarted: '#9ca6af',
                        backgroundDeleted: '#dadfe2',
                        colorDeleted: '#757e85',
                        colorUsername: '#9ca6af',
                        colorTimestamp: '#828c94',
                        backgroundDate: '#e5effa',
                        colorDate: '#505a62',
                        backgroundSystem: '#e5effa',
                        colorSystem: '#505a62',
                        backgroundMedia: 'rgba(0, 0, 0, 0.15)',
                        backgroundReply: 'rgba(0, 0, 0, 0.08)',
                        colorReplyUsername: '#0a0a0a',
                        colorReply: '#6e6e6e',
                        colorTag: '#0d579c',
                        backgroundImage: '#ddd',
                        colorNewMessages: '#1976d2',
                        backgroundScrollCounter: '#0696c7',
                        colorScrollCounter: '#fff',
                        backgroundReaction: '#eee',
                        borderStyleReaction: '1px solid #eee',
                        backgroundReactionHover: '#fff',
                        borderStyleReactionHover: '1px solid #ddd',
                        colorReactionCounter: '#0a0a0a',
                        backgroundReactionMe: '#cfecf5',
                        borderStyleReactionMe: '1px solid #3b98b8',
                        backgroundReactionHoverMe: '#cfecf5',
                        borderStyleReactionHoverMe: '1px solid #3b98b8',
                        colorReactionCounterMe: '#0b59b3',
                        backgroundAudioRecord: '#eb4034',
                        backgroundAudioLine: 'rgba(0, 0, 0, 0.15)',
                        backgroundAudioProgress: '#455247',
                        backgroundAudioProgressSelector: '#455247'
                    },

                    markdown: {
                        background: 'rgba(239, 239, 239, 0.7)',
                        border: 'rgba(212, 212, 212, 0.9)',
                        color: '#e01e5a',
                        colorMulti: '#0a0a0a'
                    },

                    room: {
                        colorUsername: '#0a0a0a',
                        colorMessage: '#67717a',
                        colorTimestamp: '#a2aeb8',
                        colorStateOnline: '#4caf50',
                        colorStateOffline: '#9ca6af',
                        backgroundCounterBadge: '#0696c7',
                        colorCounterBadge: '#fff'
                    },

                    emoji: {
                        background: '#fff'
                    },

                    icons: {
                        search: '#9ca6af',
                        add: '#1976d2',
                        toggle: '#0a0a0a',
                        menu: '#0a0a0a',
                        close: '#9ca6af',
                        closeImage: '#fff',
                        file: '#1976d2',
                        paperclip: '#1976d2',
                        closeOutline: '#000',
                        send: '#1976d2',
                        sendDisabled: '#9ca6af',
                        emoji: '#1976d2',
                        emojiReaction: 'rgba(0, 0, 0, 0.3)',
                        document: '#1976d2',
                        pencil: '#9e9e9e',
                        checkmark: '#9e9e9e',
                        checkmarkSeen: '#0696c7',
                        eye: '#fff',
                        dropdownMessage: '#fff',
                        dropdownMessageBackground: 'rgba(0, 0, 0, 0.25)',
                        dropdownRoom: '#9e9e9e',
                        dropdownScroll: '#0a0a0a',
                        microphone: '#1976d2',
                        audioPlay: '#455247',
                        audioPause: '#455247',
                        audioCancel: '#eb4034',
                        audioConfirm: '#1ba65b'
                    }
                },
            },
        }
    },
    props: {
        user: {
            type: Number,
            default: null,
        },
        showChat: {
            type: Boolean,
            default: false,
        }
    },
    created() {
        this.translations = trans.chat
        this.currentUserId = this.user
        this.updateRooms()
        this.heartbeat()
        setInterval(this.heartbeat, 60000)
    },
    mounted() {
    },
    watch: {
        showChat: function (value) {
            if (value) {
                $('#chatModal').modal({ backdrop: 'static' });
                $('#chatModal').modal('show');
            } else {
                $('#chatModal').modal('hide');
                this.chatModalClosed()
            }
        },
        totalUnreadMessageCount: function (unreadMessages) {
            this.$emit('unread-messages', unreadMessages)
        }
    },
    computed: {
        messageActions: function () {
            if (this.translations) {
                return [
                    {
                        name: 'replyMessage',
                        title: this.translations['Reply'],
                    },
                    {
                        name: 'editMessage',
                        title: this.translations['Edit Message'],
                        onlyMe: true
                    },
                    {
                        name: 'deleteMessage',
                        title: this.translations['Delete Message'],
                        onlyMe: true
                    }
                ]
            } else {
                return [];
            }
        },
        loadedRooms() {
            return this.rooms.slice(0, this.roomsLoadedCount)
        },
    },
    methods: {
        resetRooms() {
            this.loadingRooms = true
            this.rooms = []
            this.roomsLoaded = true
            this.roomsLoadedCount = 0
            this.resetMessages()
        },
        resetMessages() {
            this.messages = []
            this.messagesLoaded = false
            this.messagesPage = 1
        },
        updateRooms: function () {

            this.resetRooms()

            if (!this.currentUserId) {
              return;
            }

            let $end = '/api/chat/room'
            let self = this
            axios.get($end).then(function (response) {
                response = response.data;
                // console.log(response)
                const rooms = [];
                if (response.data.length) {
                    response.data.forEach(function (room) {
                        rooms.push(room)
                    })
                    self.rooms = rooms
                }

                if (!self.rooms.length) {
                    self.loadingRooms = false
                    self.roomsLoaded = true
                    self.roomsLoadedCount = 0
                } else {
                    self.roomsLoadedCount = self.rooms.length
                    self.loadingRooms = false
                    self.roomsLoaded = true
                    self.subscribeToChannels()
                    self.updateTotalUnreadMessageCount()

                }
            })
        },
        subscribeToChannels: function () {
            let self = this
            this.rooms.forEach(function (room) {
                // console.log(room.roomId)
                Echo.join('room.' + room.roomId)
                    .here(users => {
                        // console.log(users)
                    })
                    .joining(user => {
                        let eventRoomIndex = self.rooms.findIndex(loadedRoom => loadedRoom.roomId === room.roomId)
                        let joiningUserIndex = self.rooms[eventRoomIndex].users.findIndex(roomUser => roomUser._id === user)
                        if (joiningUserIndex !== -1) {
                            self.rooms[eventRoomIndex].users[joiningUserIndex].status.state = "online"
                            self.rooms[eventRoomIndex].users[joiningUserIndex].status.lastChanged = new Date()
                        }
                        // console.log(user + ' joined channel')
                    })
                    .leaving(user => {
                        let eventRoomIndex = self.rooms.findIndex(loadedRoom => loadedRoom.roomId === room.roomId)
                        let leavingUserIndex = self.rooms[eventRoomIndex].users.findIndex(roomUser => roomUser._id === user)
                        if (leavingUserIndex !== -1) {
                            self.rooms[eventRoomIndex].users[leavingUserIndex].status.state = "offline"
                            self.rooms[eventRoomIndex].users[leavingUserIndex].status.lastChanged = new Date()
                        }
                        // console.log(user + ' left channel')
                    })
                    .listenForWhisper('typing', user => {
                        let eventRoomIndex = self.rooms.findIndex(loadedRoom => loadedRoom.roomId === room.roomId)
                        let typingUserIndex = self.rooms[eventRoomIndex].typingUsers.findIndex(typingUser => typingUser === user)
                        // console.log(typingUserIndex)
                        if (typingUserIndex === -1) {
                            self.rooms[eventRoomIndex].typingUsers.push(user)
                        } else {
                            self.rooms[eventRoomIndex].typingUsers.splice(typingUserIndex, 1)
                        }
                    })
                    .listen('ChatMessageSent', (event) => {
                        //console.log(event)
                        let eventRoomIndex = self.rooms.findIndex(loadedRoom => loadedRoom.roomId === room.roomId)
                        if (room.roomId === self.roomId) {
                            self.messages = [...self.messages,event.message]
                        } else {
                            self.rooms[eventRoomIndex]['unreadCount'] += 1
                        }
                        self.rooms[eventRoomIndex]['lastMessage'] = event.message
                        self.rooms[eventRoomIndex]['index'] = Date.parse(event.message.date + ' ' + event.message.timestamp + ' UTC') / 1000
                        self.rooms = [...self.rooms]
                        self.updateTotalUnreadMessageCount()
                    })
                    .listen('ChatMessageDeleted', (event) => {
                        let eventRoomIndex = self.rooms.findIndex(loadedRoom => loadedRoom.roomId === room.roomId)
                        if (room.roomId === self.roomId) {
                            let eventMessageIndex = self.messages.findIndex(loadedMessage => loadedMessage._id === event.messageId)

                            self.messages[eventMessageIndex].content = ''
                            self.messages[eventMessageIndex]['deleted'] = true
                        }

                        if (self.rooms[eventRoomIndex]['lastMessage']['_id'] === event.messageId) {
                            self.rooms[eventRoomIndex]['lastMessage'].content = ''
                            self.rooms[eventRoomIndex]['lastMessage'].deleted = true
                        }

                    })
                    .listen('ChatMessageEdited', (event) => {
                        // console.log(event)
                        let eventRoomIndex = self.rooms.findIndex(loadedRoom => loadedRoom.roomId === room.roomId)
                        if (room.roomId === self.roomId) {
                            let eventMessageIndex = self.messages.findIndex(loadedMessage => loadedMessage._id === event.message._id)
                            self.messages[eventMessageIndex] = event.message
                            self.messages = [...self.messages]
                        }
                        if (self.rooms[eventRoomIndex]['lastMessage'] === event.message._id) {
                            self.rooms[eventRoomIndex]['lastMessage'] = event.message
                        }
                    });
            })
        },
        fetchMessages: function ({ room, options = {} }) {
            if (options.reset) {
                if (this.roomId) {
                    this.updateUserRoomLastMessageRead(this.roomId)
                }
                this.resetMessages()
                this.roomId = room.roomId
            }

            this.messagesLoaded = false
            let $end = '/api/chat/' + this.roomId + '/message?page=' + this.messagesPage
            let self = this

            axios.get($end).then(function (response) {
                response = response.data;
                //console.log(response)
                const messages = [];
                if (response.data.length) {
                    response.data.forEach(function (message) {
                        messages.unshift(message)
                    })
                }
                if (options.reset) {
                    self.messages = [...messages]
                } else {
                    self.messages = [...messages,...self.messages]
                }

                if (response.data.length < 25) {
                    self.messagesLoaded = true
                }

                let roomIndex = self.rooms.findIndex(loadedRoom => loadedRoom.roomId === room.roomId)
                self.rooms[roomIndex]['unreadCount'] = 0
                self.updateTotalUnreadMessageCount()
                self.messagesPage += 1
            })
        },
        sendMessage: function (args) {
            // console.log(args)
            let $end = '/api/chat/' + args.roomId + '/message'
            let roomIndex = this.rooms.findIndex(room => room.roomId === args.roomId)
            let self = this
            axios.post($end, args).then(function (response) {
                response = response.data;
                // console.log(response.data)
                if (Object.keys(response.data).length) {
                    self.messages = [...self.messages,response.data]
                    self.updateRoomLastMessage(roomIndex, response.data)
                }
            })
        },
        typingMessage({ message, roomId }) {
            if (!roomId) return
            if (message?.length > 1) {
                return (this.typingMessageCache = message)
            }
            if (message?.length === 1 && this.typingMessageCache) {
                return (this.typingMessageCache = message)
            }
            this.typingMessageCache = message
            Echo.join('room.' + roomId)
                .whisper('typing', this.currentUserId)
        },
        deleteMessage({ roomId, message}) {
            let $end = '/api/chat/message/' + message._id
            let self = this
            axios.delete($end, {message: message}).then(function (response) {
                response = response.data;
                if (Object.keys(response.data).length && response.data.success === true && self.roomId === roomId) {
                    let messageIndex = self.messages.findIndex(loadedMessage => loadedMessage._id === response.data._id)
                    self.messages[messageIndex]['content'] = '';
                    self.messages[messageIndex]['deleted'] = true;
                }
            })
        },
        editMessage({ messageId, newContent, roomId, file }) {
            let $end = '/api/chat/message/' + messageId
            let roomIndex = this.rooms.findIndex(room => room.roomId === this.roomId)
            let self = this
            axios.patch($end, {roomId: roomId, newContent: newContent}).then(function (response) {
                response = response.data;
                // console.log(response.data)
                if (Object.keys(response.data).length && self.roomId === roomId) {
                    let messageIndex = self.messages.findIndex(loadedMessage => loadedMessage._id === response.data._id)
                    self.messages[messageIndex] = response.data
                    self.messages = [...self.messages]
                    if (self.rooms[roomIndex]['lastMessage']._id === response.data._id) {
                        self.updateRoomLastMessage(roomIndex, response.data)
                    }
                }
            })
        },
        sendMessageReaction({ reaction, remove, messageId, roomId }) {
            let $end = '/api/chat/' + roomId + '/message/' + messageId + '/reaction'
            let roomIndex = this.rooms.findIndex(room => room.roomId === this.roomId)
            let self = this
            axios.patch($end, {reaction: reaction, remove: remove}).then(function (response) {
                response = response.data;
                if (Object.keys(response.data).length && self.roomId === roomId) {
                    let messageIndex = self.messages.findIndex(loadedMessage => loadedMessage._id === response.data._id)
                    self.messages[messageIndex] = response.data
                    self.messages = [...self.messages]
                    if (self.rooms[roomIndex]['lastMessage']._id === response.data._id) {
                        self.updateRoomLastMessage(roomIndex, response.data)
                    }
                }
            })
        },
        updateRoomLastMessage(roomIndex, message) {
            this.rooms[roomIndex]['lastMessage'] = message
            this.rooms[roomIndex]['index'] = Date.parse(message.date + ' ' + message.timestamp + ' UTC') / 1000
            this.rooms = [...this.rooms]
        },
        heartbeat() {
            if (!this.currentUserId) {
              return
            }

            if (this.roomId) {
                this.updateUserRoomLastMessageRead(this.roomId)
            } else {
                let $end = '/api/chat/heartbeat/' + this.currentUserId
                axios.post($end, {}).then(function (response) {
                    return true
                })
            }
        },
        chatModalClosed() {
            this.updateUserRoomLastMessageRead(this.roomId)
            this.resetMessages()
            this.roomId = null
            $('#chatModal').modal('hide');
            this.$emit('chat-closed')
        },
        updateTotalUnreadMessageCount() {
            let totalUnreadMessageCount = 0
            this.rooms.forEach(function (room) {
                totalUnreadMessageCount += room.unreadCount
            })
            this.totalUnreadMessageCount = totalUnreadMessageCount
        },
        updateUserRoomLastMessageRead(roomId) {
            if (!roomId) {
                return false
            }
            let $end = '/api/chat/last-read/' + roomId + '/' + this.currentUserId
            axios.post($end, {}).then(function (response) {
                return true
            })
        },
    }
}
</script>

<style scoped>
</style>
